"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.decode = exports.decodeChain = exports.setSchemas = exports.ValidationCoercionReporting = exports.ValidationError = exports.CREATION_DEFAULTS = void 0;
/* eslint-disable @typescript-eslint/no-explicit-any */
var ajv_1 = __importDefault(require("ajv"));
var result_1 = require("./result");
var DECODER_DEFAULTS = {
    allErrors: true,
    removeAdditional: 'all',
    format: 'full',
    strictNumbers: true,
    coerceTypes: false,
    useDefaults: false,
};
exports.CREATION_DEFAULTS = __assign(__assign({}, DECODER_DEFAULTS), { coerceTypes: true, useDefaults: true });
var errorMessage = function (data, errors, taraType) { var _a; return (_a = errors === null || errors === void 0 ? void 0 : errors.reduce(function (str, _a) {
    var dataPath = _a.dataPath, message = _a.message;
    var key = dataPath.slice(1);
    var value = data[key];
    return "" + str + dataPath + " (value: " + value + ") " + message + ", ";
}, (data === null || data === void 0 ? void 0 : data.id) ? (taraType || 'document') + "Id:(" + data.id + ")" : '')) !== null && _a !== void 0 ? _a : 'error'; };
var ValidationError = /** @class */ (function (_super) {
    __extends(ValidationError, _super);
    function ValidationError(data, errors, taraType) {
        var _this = _super.call(this, errorMessage(data, errors, taraType)) || this;
        _this.name = 'ValidationError';
        _this.errors = errors !== null && errors !== void 0 ? errors : [];
        return _this;
    }
    return ValidationError;
}(Error));
exports.ValidationError = ValidationError;
var ValidationCoercionReporting = /** @class */ (function (_super) {
    __extends(ValidationCoercionReporting, _super);
    function ValidationCoercionReporting(data, errors, taraType) {
        var _this = _super.call(this, errorMessage(data, errors, taraType)) || this;
        _this.name = 'ValidationCoercionReporting';
        _this.errors = errors !== null && errors !== void 0 ? errors : [];
        return _this;
    }
    return ValidationCoercionReporting;
}(Error));
exports.ValidationCoercionReporting = ValidationCoercionReporting;
var SchemaCache = {};
var setSchemas = function (schemas) {
    SchemaCache = schemas;
};
exports.setSchemas = setSchemas;
/**
 * Returns decoder for passed type.
 *
 * __WARNING__: in `Jest` this will return correct decoder __ONLY__
 * if it's added to mock list in `reduxStore/utils/__mocks__/schemas.ts`.
 */
function getDecoder(taraType, options) {
    if (options === void 0) { options = DECODER_DEFAULTS; }
    var schemaJSON = typeof taraType === 'string' ? SchemaCache[taraType] : taraType;
    var compileError = null;
    if (schemaJSON === undefined || schemaJSON === null) {
        compileError = new ValidationError("Schema (" + taraType + ") is not found. " +
            'Check @taraai/types generate-schemas or reduxStore/utils/__mocks__ for Jest.');
    }
    // Note: Fixes an issue with AJV on top-level anyOf/allOf with remove full.
    var opts = options;
    if (schemaJSON && (schemaJSON.anyOf || schemaJSON.allOf)) {
        opts.removeAdditional = true;
        opts.format = false;
    }
    var tara = typeof taraType === 'string' ? taraType : 'document';
    var ajv = new ajv_1.default(opts);
    var validator = ajv.compile(schemaJSON);
    function decode(data) {
        (performance === null || performance === void 0 ? void 0 : performance.mark) && performance.mark('@tara/decoder');
        var result;
        if (compileError) {
            return result_1.err(compileError);
        }
        if (validator(data)) {
            result = result_1.ok(data);
        }
        else {
            result = result_1.err(new ValidationError(data, validator.errors, tara));
        }
        (performance === null || performance === void 0 ? void 0 : performance.measure) && performance.measure('@tara/decode', '@tara/decoder');
        return result;
    }
    return decode;
}
function decodeFn(data, taraType, options) {
    if (options === void 0) { options = DECODER_DEFAULTS; }
    var decodingFunc = getDecoder(taraType, options);
    var decodingResult = decodingFunc(data);
    if (!decodingResult.isOk())
        throw decodingResult.errors;
    return decodingResult.value;
}
exports.decode = decodeFn;
var decodeChain = function (data, taraType, options) {
    if (options === void 0) { options = DECODER_DEFAULTS; }
    return new Promise(function (resolve, reject) {
        var decodingFunc = getDecoder(taraType, options);
        var decodingResult = decodingFunc(data);
        if (!decodingResult.isOk())
            return reject(decodingResult.errors);
        resolve(decodingResult.value);
    });
};
exports.decodeChain = decodeChain;
exports.default = getDecoder;
